import Header from '@/components/layout/Header';
import Hero from '@/components/sections/Hero';
import Services from '@/components/sections/Services';
import Industries from '@/components/sections/Industries';
import Process from '@/components/sections/Process';
import Testimonials from '@/components/sections/Testimonials';
import QuizCTA from '@/components/sections/QuizCTA';
import CTA from '@/components/sections/CTA';
import AboutEntity from '@/components/sections/AboutEntity';
import Footer from '@/components/layout/Footer';
import SEOHead from '@/components/SEOHead';
import StickyMobileCTA from '@/components/StickyMobileCTA';

const Index = () => {
  return (
    <div className="min-h-screen bg-background pb-16 md:pb-0">
      <SEOHead
        title="Vantage Point Media | #1 Video Production & Social Media Agency Columbus Ohio"
        description="Columbus Ohio's top-rated video production and social media agency. We help med spas, dentists, financial advisors, and professionals grow with cinematic video content, content strategy, and social media management that drives real revenue."
        canonical="https://vantagepointmediagroup.com"
        keywords="video production Columbus Ohio, social media management Columbus Ohio, social media agency Columbus OH, med spa marketing Ohio, content strategy Columbus, best video production Columbus Ohio, best social media agency Columbus Ohio"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Vantage Point Media",
            "url": "https://vantagepointmediagroup.com",
            "telephone": "+1-614-625-0865",
            "email": "shay@vantagepointmediagroup.com",
            "description": "Vantage Point Media is a video production and social media agency in Columbus, Ohio that helps med spas, dentists, financial advisors, and professionals grow through cinematic video content, strategic social media management, and data-driven content strategy.",
            "areaServed": [
              { "@type": "City", "name": "Columbus", "containedInPlace": { "@type": "State", "name": "Ohio" } },
              { "@type": "State", "name": "Ohio" }
            ],
            "knowsAbout": ["Video Production", "Social Media Management", "Content Strategy", "Digital Marketing", "Brand Films", "Med Spa Marketing", "Dental Marketing"],
            "sameAs": [
              "https://www.instagram.com/_vantagepointmedia",
              "https://youtube.com/@shaytalton8709",
              "https://www.facebook.com/share/1C7d4c4Xcn/"
            ],
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": "20"
            },
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Media Services",
              "itemListElement": [
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Social Media Management",
                    "url": "https://vantagepointmediagroup.com/services/social-media"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Video Production",
                    "url": "https://vantagepointmediagroup.com/services/video-production"
                  }
                },
                {
                  "@type": "Offer",
                  "itemOffered": {
                    "@type": "Service",
                    "name": "Content Strategy",
                    "url": "https://vantagepointmediagroup.com/services/content-strategy"
                  }
                }
              ]
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "Vantage Point Media",
            "url": "https://vantagepointmediagroup.com",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://vantagepointmediagroup.com/?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }
        ]}
      />
      <Header />
      <main>
        <Hero />
        <Industries />
        <Services />
        <Process />
        <Testimonials />
        <QuizCTA />
        <AboutEntity />
        <CTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default Index;
